export const externalDomain = "https://www.scafflow.com";
export const debugMode = false;

